import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingBag } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onBookClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMenuOpen(false);
      }
    }
  };

  const goToShop = () => {
    navigate('/nursery-shop');
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 
              onClick={() => navigate('/')}
              className="text-2xl font-bold text-black cursor-pointer" 
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              AGreenerSide
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-black transition-colors duration-200 font-medium"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('experiences')}
              className="text-gray-700 hover:text-black transition-colors duration-200 font-medium"
            >
              Experiences
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="text-gray-700 hover:text-black transition-colors duration-200 font-medium"
            >
              Gallery
            </button>
            <Button 
              onClick={goToShop}
              className="bg-white text-black border-2 border-black hover:bg-black hover:text-white transition-all duration-200 font-bold"
            >
              <ShoppingBag className="mr-2" size={18} />
              Shop Nursery
            </Button>
            <Button 
              onClick={onBookClick}
              className="bg-black text-white hover:bg-gray-800 transition-all duration-200"
            >
              Book a Visit
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-black transition-colors duration-200"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 pt-2 pb-4 space-y-2">
            <button 
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-md transition-colors duration-200"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('experiences')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-md transition-colors duration-200"
            >
              Experiences
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-md transition-colors duration-200"
            >
              Gallery
            </button>
            <Button 
              onClick={goToShop}
              className="w-full bg-white text-black border-2 border-black hover:bg-black hover:text-white transition-all duration-200 font-bold mt-2"
            >
              <ShoppingBag className="mr-2" size={18} />
              Shop Nursery
            </Button>
            <Button 
              onClick={() => {
                onBookClick();
                setIsMenuOpen(false);
              }}
              className="w-full bg-black text-white hover:bg-gray-800 transition-all duration-200 mt-2"
            >
              Book a Visit
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
